import Native from "./native";
import { addEvent } from "../utils/events";
import { isVideo } from "../utils/general";

class HTML5Media extends Native {

    startTime = 0;
    constructor(videoElement, media, startTime) {
        super(videoElement, media);
        this.startTime = startTime;
        this.media = media
        this.videoEl.addEventListener('error',this._assign);
        this.videoEl.addEventListener('loadedmetadata',this._assign);
        if (!isVideo(videoElement)) {
            throw new TypeError('Native method only supports video/audio tags');
        }
        return this;
    }

    _assign = (event) => {
        if (event.type === 'error') {
            const details = {
                detail: {
                    type: 'HTML5',
                    message: event.message,
                    data: event,
                },
            };
            const errorEvent = addEvent('playererror', details);
            this.videoEl.dispatchEvent(errorEvent);
        } else {
            if(event.type == 'loadedmetadata' && this.startTime > 0) {
                this.videoEl.currentTime = this.startTime;
            }
        }
    }

    canPlayType(mimeType) {
        return !!(this.videoEl.canPlayType(mimeType).replace('no', ''));
    }

    load() {
        this.videoEl.setAttribute('type', this.media.type)
        this.videoEl.setAttribute('src', this.media.src)
        this.videoEl.load();
    }

    destroy() {
        this.videoEl.removeAttribute('type')
        this.videoEl.removeAttribute('src')
        this.videoEl.removeEventListener('error',this._assign);
        this.videoEl.removeEventListener('loadedmetadata',this._assign);
        return this;
    }

    set src(media) {
        this.videoEl.src = media.src;
    }
}

export default HTML5Media;
